import React from 'react';
import IconTooltip from 'components/IconToolTip';

import { Field, FieldArray } from 'redux-form';
import { BankStatemnetArray } from '../utilsForm';
import styles from './koinworksForm.css';
import UploadFile from '../UploadFile';

class KoinworksUploadForm extends React.Component {
  state = {
    showSlideshow: false,
  };

  static downloadBankTutorial() {
    const bankTutorialPDF =
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/Bank+Statement+Tutorial+-+KoinWorks+-+KoinBisnis.pdf';
    const a = document.createElement('a');
    const clickEvent = new window.MouseEvent('click');
    a.setAttribute('href', bankTutorialPDF);
    a.setAttribute('download', bankTutorialPDF);
    a.setAttribute('target', '_blank');
    a.dispatchEvent(clickEvent);
  }

  render() {
    const { isMarried } = this.props;

    return (
      <div className={`col-md-12 col-lg-12`}>
        <div className="col-md-3">
          <label className={`${styles['title-information']}`}>
            Required Document
          </label>
          <p>Please scan and upload following documents.</p>
          <p>
            Format file should be <b>jpg, png, jpeg or pdf</b>
          </p>
          <p>
            File size should be less than <b>2MB</b>
          </p>
        </div>
        <div className="col-md-9">
          <div className="form-group row">
            <label
              htmlFor="kk"
              className={`col-sm-4 ${styles['upload-label']}`}
            >
              Kartu Keluarga
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <div
                className={`${styles['float-right']} ${styles['full-width']}`}
              >
                <Field
                  type="file"
                  name="kk"
                  component={UploadFile}
                  className={`${styles['form-control-file']}`}
                  allowPDF
                />
              </div>
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="ktp"
              className={`col-sm-4 ${styles['upload-label']}`}
            >
              KTP
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <div
                className={`${styles['float-right']} ${styles['full-width']}`}
              >
                <Field
                  type="file"
                  name="ktp"
                  component={UploadFile}
                  className={`${styles['form-control-file']}`}
                  allowPDF
                />
              </div>
            </div>
          </div>
          {/* ==== BUSINESS ONLY - KTP PENGURUS ====== */
          this.props.loansType.toLowerCase() !== 'personal' && (
            <div className="form-group row">
              <label
                htmlFor="ktp_komisaris_url"
                className={`col-sm-4 ${styles['upload-label']}`}
              >
                KTP Pengurus
                <red>*</red>
              </label>
              <div className="col-sm-8">
                <div
                  className={`${styles['float-right']} ${styles['full-width']}`}
                >
                  <Field
                    type="file"
                    name="ktp_komisaris_url"
                    component={UploadFile}
                    className={`${styles['form-control-file']}`}
                    allowPDF
                  />
                </div>
              </div>
            </div>
          )}
          {isMarried === 'Married' && (
            <div className="form-group row">
              <label
                htmlFor="ktp_spouse"
                className={`col-sm-4 ${styles['upload-label']}`}
              >
                KTP of Spouse
                <red>*</red>
              </label>
              <div className="col-sm-8">
                <div
                  className={`${styles['float-right']} ${styles['full-width']}`}
                >
                  <Field
                    type="file"
                    name="ktp_spouse"
                    component={UploadFile}
                    className={`${styles['form-control-file']}`}
                    allowPDF
                  />
                </div>
              </div>
            </div>
          )}
          <div className="form-group row">
            <label
              htmlFor="npwp"
              className={`col-sm-4 ${styles['upload-label']}`}
            >
              NPWP of Personal
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <div
                className={`${styles['float-right']} ${styles['full-width']}`}
              >
                <Field
                  type="file"
                  name="npwp"
                  component={UploadFile}
                  className={`${styles['form-control-file']}`}
                  allowPDF
                />
              </div>
            </div>
          </div>
          {/** BUSINESS TYPE ONLY */
          this.props.loansType.toLowerCase() !== 'personal' && (
            <div>
              <div className="form-group row">
                <label
                  htmlFor="akte_perusahaan"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Akte Perusahaan
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="akte_perusahaan"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="akte_perubahan"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Akte Perubahan Terakhir Perusahaan
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="akte_perubahan"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="npwp_company"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  NPWP of Business
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="npwp_company"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="financial_statement"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Financial Statement
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="financial_statement"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="siup"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  SIUP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="siup"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="domicile"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Domisili
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="domicile"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="tdp"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Tanda Daftar Perusahaan
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="tdp"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="form-group row">
            <label
              htmlFor="inputEmail3"
              className={`col-sm-4 ${styles['upload-label']}`}
              style={{ display: 'flex' }}
            >
              <div>
                Bank Statement <br /> of Personal <br /> (Recent 3 months){' '}
                <red>*</red>{' '}
              </div>
              <div className={styles['icon-container']}>
                <IconTooltip
                  text="How to prepare electronic bank statement?"
                  iconElement={
                    <i
                      style={{ fontSize: 25, color: 'cornflowerblue' }}
                      className="fa fa-question-circle-o"
                    />
                  }
                  onIconClick={this.props.openSlideshow}
                />
                <IconTooltip
                  text="Download bank tutorial as pdf"
                  iconElement={
                    <i
                      style={{ fontSize: 25, color: 'cornflowerblue' }}
                      className="fa fa-download"
                    />
                  }
                  onIconClick={KoinworksUploadForm.downloadBankTutorial}
                />
              </div>
            </label>
            <div className="col-sm-8">
              <div
                className={`${styles['float-right']} ${styles['full-width']}`}
              >
                <FieldArray
                  name="bank_statement_array"
                  component={BankStatemnetArray}
                />
              </div>
            </div>
          </div>
          {/** Bank Statement business */
          this.props.loansType.toLowerCase() !== 'personal' && (
            <div className="form-group row">
              <label
                htmlFor="bank_statement_company_array"
                className={`col-sm-4 ${styles['upload-label']}`}
                style={{ display: 'flex' }}
              >
                <div>
                  Bank Statement <br /> of Company/Business <br /> (Recent 3
                  months) <red>*</red>{' '}
                </div>
                <div className={styles['icon-container']}>
                  <IconTooltip
                    text="How to prepare electronic bank statement?"
                    iconElement={
                      <i
                        style={{ fontSize: 25, color: 'cornflowerblue' }}
                        className="fa fa-question-circle-o"
                      />
                    }
                    onIconClick={this.props.openSlideshow.bind(this)}
                  />
                  <IconTooltip
                    text="Download bank tutorial as pdf"
                    iconElement={
                      <i
                        style={{ fontSize: 25, color: 'cornflowerblue' }}
                        className="fa fa-download"
                      />
                    }
                    onIconClick={KoinworksUploadForm.downloadBankTutorial}
                  />
                </div>
              </label>
              <div className="col-sm-8">
                <div
                  className={`${styles['float-right']} ${styles['full-width']}`}
                >
                  <FieldArray
                    name="bank_statement_company_array"
                    component={BankStatemnetArray}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default KoinworksUploadForm;
